import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { GoogleMap, GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { TextFieldComponent } from '../../../../shared/components/fields/text-field/text-field.component';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
@Component({
  selector: 'app-maps-field-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    GoogleMapsModule,
    GoogleMap,
    TextFieldComponent,
    MatIconModule,
    MatCardModule
  ],
  templateUrl: './maps-field-dashboard.component.html',
  styleUrls: ['./maps-field-dashboard.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapsFieldDashboardComponent {
  @Input() coordinates: { altitude: number; lat: number; lng: number, uuid:string, comune:string, tipoPuntoCampionamento:string }[] = [];
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  center: google.maps.LatLngLiteral = { lat: 41.8992, lng: 12.5450 };
  zoom = 5.3;
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    tilt: 0,
    clickableIcons: false,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    zoomControl: true,
    scrollwheel: false,
    gestureHandling: 'auto',
    keyboardShortcuts: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
  };
  markerPositions: google.maps.LatLngLiteral[] = [];
constructor(private router:Router){}
  markerClustererImagePath ='https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';

  addMarker(event: google.maps.MapMouseEvent) {
    this.markerPositions.push(event?.latLng?.toJSON()!);
  }
  public openInfoWindow(marker: MapMarker, infoWindow: MapInfoWindow) {
    infoWindow.open(marker);
  }
   navigateToDetail(uuid: string) {
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/');
    urlSegments.pop();
    urlSegments.push('punti-campionamento');
    urlSegments.push(uuid.toString());
    const newUrl = urlSegments.join('/');
    this.router.navigate([newUrl]);
   }  
   checkEmptyArray(el:any){
    return el.length != 0
  }
}
